export default {
    title: "Pesquisa enviada",
    header: "@:views.survey.submitted.title",
    message: "Obrigado pelo seu feedback.",
}